module.exports = __webpack_public_path__ + "static/img/suv-orange.d8951be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/suv-orange.svg
// module id = WPa4
// module chunks = 82